import { createUseUser } from "@decocms/apps-vtex/hooks/createUseUser";
import { invoke } from "~/server/invoke";

export type { Person } from "@decocms/apps-vtex/loaders/user";

export const { useUser, resetUser } = createUseUser({ invoke });
